import { render, staticRenderFns } from "./FormRouteTransporter.vue?vue&type=template&id=5012a81a&scoped=true&"
import script from "./FormRouteTransporter.vue?vue&type=script&lang=js&"
export * from "./FormRouteTransporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5012a81a",
  null
  
)

export default component.exports